import React from "react"
import { Navigate, Route, Routes } from 'react-router-dom'

import Dashboard from "../Portal/Dashboard/Dashboard"

import Alert from "../Portal/Alert/Alert"
import Live from "../Portal/Surveillance/Live/Live"

import CameraList from "../Portal/Surveillance/Cameras/CameraList"
import CameraPlayback from "../Portal/Surveillance/Cameras/CameraPlayback"

import ProximityList from "../Portal/Surveillance/Proximity/ProximityList"

import PermitToWorkList from "../Portal/Digitalization/PermitToWork/PermitToWorkList"
import PermitToWorkCreate from "../Portal/Digitalization/PermitToWork/PermitToWorkCreate"
import PermitToWorkDetail from "../Portal/Digitalization/PermitToWork/PermitToWorkDetail"
import PermitToWorkTemplates from "../Portal/Digitalization/PermitToWork/PermitToWorkTemplates"
import PermitToWorkTemplateDetail from "../Portal/Digitalization/PermitToWork/PermitToWorkTemplateDetail"

import AssetList from "../Portal/Digitalization/AssetsTracking/AssetList"
import AssetTypes from "../Portal/Digitalization/AssetsTracking/AssetTypes"
import AssetsListDetail from "../Portal/Digitalization/AssetsTracking/AssetsListDetail"
import AssetTypesDetail from "../Portal/Digitalization/AssetsTracking/AssetTypesDetail"

import VRTrainingRecord from "../Portal/Digitalization/VRTraining/VRTrainingRecord"

import SmartwatchConfinedSpace from "../Portal/SmartDevice/Smartwatch/ConfinedSpace/SmartwatchConfinedSpace"
import SmartwatchConfinedSpaceDevices from "../Portal/SmartDevice/Smartwatch/ConfinedSpace/SmartwatchConfinedSpaceDevices"
import SmartwatchConfinedSpaceZones from "../Portal/SmartDevice/Smartwatch/ConfinedSpace/SmartwatchConfinedSpaceZones"
import SmartwatchConfinedSpaceHistory from "../Portal/SmartDevice/Smartwatch/ConfinedSpace/SmartwatchConfinedSpaceHistory"
import SmartwatchConfinedSpaceStandbyPerson from "../Portal/SmartDevice/Smartwatch/ConfinedSpace/SmartwatchConfinedSpaceStandbyPerson"

import SmartwatchOutdoor from "../Portal/SmartDevice/Smartwatch/Outdoor/SmartwatchOutdoor"
import SmartwatchOutdoorDevices from "../Portal/SmartDevice/Smartwatch/Outdoor/SmartwatchOutdoorDevices"
import SmartwatchOutdoorGeofencing from "../Portal/SmartDevice/Smartwatch/Outdoor/SmartwatchOutdoorGeofencing"
import SmartwatchOutdoorHistory from "../Portal/SmartDevice/Smartwatch/Outdoor/SmartwatchOutdoorHistory"

import GasData from "../Portal/SmartDevice/GasDetector/GasData"
import GasDataHistory from "../Portal/SmartDevice/GasDetector/GasDataHistory"

import FloodData from "../Portal/SmartDevice/FloodSensor/FloodData"
// import FloodHistory from "../Portal/SmartDevice/FloodSensor/FloodHistory"

import SmartlockData from "../Portal/SmartDevice/Smartlock/SmartlockData"
import SmartlockHistory from "../Portal/SmartDevice/Smartlock/SmartlockHistory"

import AccessControl from "../Portal/SmartDevice/AccessControl/AccessControl"

import NetworkRouter from "../Portal/ProjectManagement/DeviceManagement/NetworkRouter"
import NetworkRouterDetail from "../Portal/ProjectManagement/DeviceManagement/NetworkRouterDetail"

import Workers from "../Portal/ProjectManagement/Workers/Workers"
import SystemUsers from "../Portal/ProjectManagement/SystemUsers/SystemUsers"
import SystemLog from "../Portal/ProjectManagement/SystemLog/SystemLog"

import Portal from "./Portal"

const PortalRouter = () => {
  return (
    <Routes>
      <Route path='/' element={<Portal />}>
        <Route index element={<Navigate to="./dashboard" replace />} />

        <Route exact path="dashboard" element={<Dashboard />} />

        <Route exact path="alert" element={<Alert />} />
        <Route exact path="live" element={<Live />} />

        <Route path="cameras">
          <Route path="list" element={<CameraList />} />
          <Route path="playback" element={<CameraPlayback />} />
        </Route>

        <Route path="proximity">
          <Route path="list" element={<ProximityList />} />
        </Route>

        <Route path="permit_to_work">
          <Route exact path="list" element={<PermitToWorkList />} />
          <Route exact path="list/:template_id" element={<PermitToWorkCreate />} />
          <Route exact path="list/:template_id/:form_id" element={<PermitToWorkDetail />} />
          <Route exact path="templates" element={<PermitToWorkTemplates />} />
          <Route exact path="templates/:template_id" element={<PermitToWorkTemplateDetail />} />
        </Route>

        <Route path="assets_tracking">
          <Route exact path="list" element={<AssetList />} />
          <Route exact path="list/:assets_id" element={<AssetsListDetail />} />
          <Route exact path="types" element={<AssetTypes />} />
          <Route exact path="types/:type_id" element={<AssetTypesDetail />} />
        </Route>

        <Route path="vr_training">
          <Route exact path="records" element={<VRTrainingRecord />} />
        </Route>

        <Route path="confined_space_smartwatch">
          <Route exact path="list" element={<SmartwatchConfinedSpace />} />
          <Route exact path="devices" element={<SmartwatchConfinedSpaceDevices />} />
          {/* <Route exact path="zones" element={<SmartwatchConfinedSpaceZones />} /> */}
          <Route exact path="history" element={<SmartwatchConfinedSpaceHistory />} />
          {/* <Route exact path="standby_person" element={<SmartwatchConfinedSpaceStandbyPerson />} /> */}
        </Route>

        <Route path="outdoor_smartwatch">
          <Route exact path="list" element={<SmartwatchOutdoor />} />
          <Route exact path="devices" element={<SmartwatchOutdoorDevices />} />
          <Route exact path="geofencing" element={<SmartwatchOutdoorGeofencing />} />
          <Route exact path="history" element={<SmartwatchOutdoorHistory />} />
        </Route>

        <Route path="gas_detector">
          <Route exact path="list" element={<GasData />} />
          <Route exact path="list/:device_id" element={<GasDataHistory />} />
        </Route>

        <Route path="flood_sensor">
          <Route exact path="list" element={<FloodData />} />
          {/* <Route exact path="list/:device_id" element={<FloodHistory />} /> */}
        </Route>

        <Route path="smart_lock">
          <Route exact path="list" element={<SmartlockData />} />
          <Route exact path="list/:device_id" element={<SmartlockHistory />} />
        </Route>

        <Route path="access_control">
          <Route exact path="list" element={<AccessControl />} />
        </Route>

        <Route path="confined_space">
          <Route exact path="zones" element={<SmartwatchConfinedSpaceZones />} />
          <Route exact path="standby_person" element={<SmartwatchConfinedSpaceStandbyPerson />} />
        </Route>

        <Route path="device_management">
          <Route exact path="network_router" element={<NetworkRouter />} />
          <Route exact path="network_router/:device_id" element={<NetworkRouterDetail />} />
        </Route>

        <Route exact path="workers" element={<Workers />} />
        <Route exact path="system_users" element={<SystemUsers />} />
        <Route exact path="system_log" element={<SystemLog />} />
      </Route>
    </Routes>
  )
}

export default PortalRouter
